var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 4.2333 4.2333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.54255 0 0 .54255 -64.505 -145.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m122.79 268.85c-2.1518 0-3.9023 1.7506-3.9023 3.9023 0 2.1518 1.7506 3.9004 3.9023 3.9004s3.9004-1.7486 3.9004-3.9004c0-2.1518-1.7486-3.9023-3.9004-3.9023zm0 0.48828c1.8882 0 3.4141 1.5258 3.4141 3.4141 0 1.8882-1.5258 3.4141-3.4141 3.4141-1.8882 0-3.4141-1.5258-3.4141-3.4141 0-1.8882 1.5258-3.4141 3.4141-3.4141z",
    strokeLinecap: "round",
    style: {
      InkscapeStroke: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m120.73 272.15-0.2685 0.83156 1.75 1.8245 2.9162-3.2586-0.32468-0.8431-2.6453 2.9089z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmed);
export default __webpack_public_path__ + "static/media/confirmed.ca73935144488bbddaae8340692c532b.svg";
export { ForwardRef as ReactComponent };